export default function Init() {
  $(function () {
    var token;
    token = $('meta[name="csrf-token"]').attr("content");
    return $.ajaxPrefilter(function (options, originalOptions, xhr) {
      return xhr.setRequestHeader("X-CSRF-Token", token);
    });
  });

  // remove json render on back button
  $.ajaxSetup({
    beforeSend: function (xhr) {
      return xhr.setRequestHeader("Accept", "application/json");
    },
    cache: false,
  });
  var gon;
}
